"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var login_service_1 = require("../../service/login.service");
var user_1 = require("../../../shared/model/user");
var router_1 = require("@angular/router");
var toast_service_1 = require("../../../shared/service/toast.service");
var LoginComponent = /** @class */ (function () {
    function LoginComponent(loginService, router, _toastService) {
        this.loginService = loginService;
        this.router = router;
        this._toastService = _toastService;
        this.user = new user_1.User();
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loginService.login$
            .subscribe(function () { return _this.router.navigate(['']); });
        this.loginService.error$
            .subscribe(function (loginError) {
            _this.showMessage('Usuário ou senha incorretos.');
        });
    };
    LoginComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    LoginComponent.prototype.login = function () {
        this.loginService.login(this.user);
    };
    LoginComponent.prototype.showMessage = function (error) {
        this._toastService.showMessage(error, 4000);
    };
    LoginComponent.ctorParameters = function () { return [{ type: login_service_1.LoginService }, { type: router_1.Router }, { type: toast_service_1.ToastService }]; };
    return LoginComponent;
}());
exports.LoginComponent = LoginComponent;
//# sourceMappingURL=login.component.js.map


// WEBPACK FOOTER //
// login.component.js